import { render, staticRenderFns } from "./AppTabHeader.vue?vue&type=template&id=7c6c61b2&scoped=true&"
import script from "./AppTabHeader.vue?vue&type=script&lang=js&"
export * from "./AppTabHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppTabHeader.vue?vue&type=style&index=0&id=7c6c61b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6c61b2",
  null
  
)

export default component.exports